import { Stack } from 'expo-router';
import { CartProvider as MinimalCartProvider } from 'features/cart/cart-provider';

import { useGetCartGestureEnabledExperiment } from 'experiments/use-disable-cart-back-gesture';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { CartProvider } from 'state/cart';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const unstable_settings = {
  initialRouteName: 'cart/index',
};

export default function CartLayout() {
  const gestureEnabled = useGetCartGestureEnabledExperiment();
  const enableMinimalCartUI = useFlag(LaunchDarklyFlag.ENABLE_MINIMAL_CART_UI);
  const isUnifiedMenuEnabled = useEnableUnifiedMenu();

  if (enableMinimalCartUI && isUnifiedMenuEnabled) {
    return (
      <MinimalCartProvider>
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: 'transparent' },
            gestureEnabled,
          }}
        >
          <Stack.Screen name="cart/index" />
        </Stack>
      </MinimalCartProvider>
    );
  }

  return (
    <CartProvider>
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: 'transparent' },
          gestureEnabled,
        }}
      >
        <Stack.Screen name="cart/index" />
        <Stack.Screen name="cart/payment/index" />
        <Stack.Screen name="cart/payment/store-confirmation" />
        <Stack.Screen
          name="cart/extras"
          options={{ presentation: 'modal', animation: 'slide_from_bottom', gestureEnabled: true }}
        />
      </Stack>
    </CartProvider>
  );
}
